// extracted by mini-css-extract-plugin
export default {"container":"Benefits_container__dt9Y7","hr":"Benefits_hr__5VOlQ","firstTitle":"Benefits_firstTitle__GgWIg"};